module.exports = __webpack_public_path__ + "static/media/send-letter-info-img3@2x.fabdc243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img3@2x.png
// module id = 1316
// module chunks = 1